import { Title } from '@angular/platform-browser';
import { THIS_APP_NAME } from '../../../environments/environment';
declare var $;

/** UIに関するメソッドをまとめるクラス */
export class UtilManipulateUI {

  /** TOPへボタンの表示非表示 */
  scrollTopBtnVisible = false;

  constructor(
    private title: Title
  ) {}

  /** 現在のフォーカス要素 */
  currentFocus;

  /** フォーカスを次のinputへ移動
   * @param {any} event テンプレートから受け取った$event
   * @param {string} id 現フォーカス中のタグのid名
   * @param {string[]} searchFocusSeq 検索部のフォーカス対象
   * @param {string[]} detailFocusSeq 詳細部のフォーカス対象
   */
  moveNextFocus(event: any, id: string, searchFocusSeq: string[], detailFocusSeq: string[] = []): void {
    if (event.keyCode === 13) {
      let focusSeq;
      // 現在のフォーカス位置は検索部、詳細部のどちらか判定
      if (searchFocusSeq.indexOf(id) > -1) {
        focusSeq = searchFocusSeq;
      } else {
        focusSeq = detailFocusSeq;
      }
      let nextIndex = focusSeq.indexOf(id) + 1;
      // 移動数量を判定
      let loopEnd = false;
      for (let i = 0; i < 100; i++) {
        // 移動先がreadonlyの場合は次のinputへ移動
        const element = $('#' + focusSeq[nextIndex])[0];
        if (element === undefined) {
          break;
        }
        const inputType = element.localName;
        switch (inputType) {
          case 'input':
            if ($('#' + focusSeq[nextIndex]).attr('readonly') === 'readonly') {
              nextIndex++;
            } else {
              loopEnd = true;
            }
            break;

          case 'wj-input-number':
            let isReadOnly = false;
            for (let j = 0; j < element.classList.length; j++) {
              if (element.classList[j] === 'wj-state-readonly') {
                isReadOnly = true;
                break;
              }
            }
            if (isReadOnly) {
              nextIndex++;
            } else {
              loopEnd = true;
            }
            break;

          default:
            loopEnd = true;
            break;
        }
        if (loopEnd) {
          break;
        }
      }
      if (nextIndex <= focusSeq.length - 1) {
        $('#' + focusSeq[nextIndex]).focus();
      }
    }
  }

  /** 現在のフォーカス記憶 */
  memorizeFocus(): void {
    this.currentFocus = $(':focus');
  }

  /** 記憶したフォーカスから１つ戻す */
  prevFocus(): void {
    $(this.currentFocus).prev().focus();
  }

  /** 画面をスクロール */
  scrollToTop() {
    window.scrollTo(0, 0);
  }
  /** 特定座標へスクロールする */
  scrollTo(any: string) {
    let x = null;
    let y = null;
    if (any === 'bottom') {
      x = 0;
      y = window.document.documentElement.offsetHeight;
    }
    if (x >= 0 && y >= 0) {
      this.scrollToAny(x, y);
    }
  }
  scrollToAny(x: number, y: number) {
    window.scrollTo(x, y);
  }

  setTitleBar(pageTitle: string) {
    this.title.setTitle(`${THIS_APP_NAME} - ${pageTitle}`);
  }

  lostFocus() {
    const element = document.activeElement as any;
    element.blur();
  }

  isShowDropDownButton() {
    if (window.innerWidth > 767) {
      return true;
    }
    return false;
  }

  /** 特定の要素を全画面表示する
   * (ユーザーからの何らかの入力によるメソッド実行でないとブラウザに実行拒否されるので注意)
   */
  fullScreen(target: any = null) {
    if (!target) {
      target = document.getElementsByTagName('html')[0];
    }
    const doc = document as any;
    // Chrome15+, Safari5.1+, Opera15+
    if (target.webkitRequestFullscreen) {
      target.webkitRequestFullscreen();
      // FF10+
    } else if (target.mozRequestFullScreen) {
      target.mozRequestFullScreen();
      // IE11+
    } else if (target.msRequestFullscreen) {
      target.msRequestFullscreen();
      // HTML5 Fullscreen API仕様
    } else if (target.requestFullscreen) {
      target.requestFullscreen();
      // 未対応
    } else {
      console.log('ご利用のブラウザはフルスクリーン操作に対応していません');
    }
  }

  /** 全画面表示をキャンセル */
  cancelFullScreen(target: any = null) {
    if (!target) {
      target = document.getElementsByTagName('html')[0];
    }
    const doc = document as any;
    // Chrome15+, Safari5.1+, Opera15+
    if (target.webkitRequestFullscreen) {
      doc.webkitCancelFullScreen();
      // FF10+
    } else if (target.mozRequestFullScreen) {
      doc.mozCancelFullScreen();
      // IE11+
    } else if (target.msRequestFullscreen) {
      doc.msExitFullscreen();
      // HTML5 Fullscreen API仕様
    } else if (target.requestFullscreen) {
      doc.cancelFullScreen();
    } else {
      console.log('ご利用のブラウザはフルスクリーン操作に対応していません');
    }
  }

  isFullScreen() {
    const doc = document as any;
    return doc.fullscreen;
  }

  openModal(modalName: string) {
    $('#' + modalName).modal({backdrop: 'static'}, 'show');
  }

  closeModal(modalName: string) {
    $('#' + modalName).modal('hide');
  }

  /** Bootstrapのポップオーバーの表示/非表示を切替
   * @parm elementId HTML要素のID
   */
  popoverToggle(elementId: string) {
    $('#' + elementId).popover('toggle');
  }
  /** Bootstrapのポップオーバーを非表示
 * @parm elementId HTML要素のID
 */
  popoverHide(elementId: string) {
    console.log('hide');
    $('#' + elementId).popover('hide');
  }

  /** icongramのURLを生成 */
  public icongram(type :string, iconName: string, size = 20, hexColor = '666666'): string {
    return `https://icongr.am/${type}/${iconName}.svg?size=${size}&color=${hexColor}`;
  }
}
